/**
 * ROC 7
 * Copyright 2016 ROC Commerce
 * 
 * Any modifications required of core files should be handled in supplemental files 
 * or duplicates of said core files. This is to assist in upgrade paths.
 */


// Favorites module
define('modules/Favorites/Favorites',[
    'jquery',
    'global/all',
    './FavoritesManager',
    'modules/Cart/all',
    'modules/QuickView/QuickView',
    './FavoritesCustomizations',
    'plugins/magnific-popup',
    'plugins/jquery.rateit.min'
], function ($, Roc, FavoritesManager, Cart, QuickView, Customizations) {
    'use strict';

    var baseUrl;
    var listId;
    var pagination;
    var isModalOpen = false;
    var itemToMove = null;
    var itemToUpdate = null;

    var listActionsType = {
        EDIT: 0,
        DELETE: 1,
        SHARE_PUBLIC: 2,
        SHARE_PRIVATE: 3
    };

    function openModal(content) {
        isModalOpen = true;
        Roc.UI.Modal.open(content);
    }

    function closeModal() {
        if (isModalOpen) {
            isModalOpen = false;
            Roc.UI.Modal.close();
        }
    }

    function changeListNameEvt() {
        $(document).on('click', '#changeListNameBtn', function () {
            var newName = $('#editName').val();
            if (newName.length > 0) {
                var listData = {
                    'ListId': listId,
                    'Name': newName
                };
                FavoritesManager.updateList(listData);
            } else {
                Roc.UI.displayErrorPopup('Lists name must have a value');
            }
        });
    }

    function deleteItemEvt() {
        $(document).on('click', '.deleteItemBtn', function () {
            if (confirm('Are you sure you want to delete this item?')) {
                FavoritesManager.deleteItem($(this).closest('.itemWrapper').attr('data-product-id'), listId);
            }
        });
    }

    function editItemEvt() {
        $(document).on('click', '.editItemBtn', function () {
            var $itemWrapper = $(this).closest('.itemWrapper');
            var itemId = $itemWrapper.attr('data-item-id');
            FavoritesManager.getItem(itemId);
        });
    }


    function displayEditItemEvt(data) {
        if (data && data.Result === true) {
            Roc.UI.template('editFavoritesItem-Tmp', data).then(function (renderedTemplate) {
                openModal(renderedTemplate);
            });
        } else {
            Roc.UI.Modal.alert('There was an error while trying to get item details');
        }
    }

    function displayEditListEvt(data) {
        if (data && data.Result === true) {
            Roc.UI.template('favoritesList-Tmp', data).then(function (renderedTemplate) {
                openModal(renderedTemplate);
            });
        } else {
            Roc.UI.Modal.alert('There was an error while trying to get list details');
        }
    }

    function saveEditItemEvt() {
        $(document).on('click', '#saveEditItemBtn', function () {
            var $popupHtml = $.magnificPopup.instance.content;
            var requestData = {
                'ProductId': $popupHtml.attr('data-product-id'),
                'Comment': $popupHtml.find('textarea.comments').val(),
                'Priority': $popupHtml.find('select.priority').val(),
                'ListId': listId
            }
            FavoritesManager.updateItem(requestData);
            Roc.Core.lockButton('#saveEditItemBtn');
        });
    }

    function saveEditListEvt() {
        $(document).on('click', '#editListBtn', function () {
            var $popupHtml = $.magnificPopup.instance.content;
            var requestData = {
                'Privacy': parseInt($popupHtml.find('select.privacyLevel').val()),
                'Name': $popupHtml.find('input#favoritesName').val(),
                'ListId': listId
            }
            FavoritesManager.updateList(requestData);
            Roc.Core.lockButton('#editListBtn');
        });
    }

    function updateItemQtyEvt() {
        $(document).on('click', '.updateItemQtyBtn', function () {
            var $input = $(this).closest('.itemQty').find('.wantsQty');
            var $button = $(this).closest('.itemQty').find('.updateItemQtyBtn');
            if ($input.attr('data-originalval') !== $input.val()) {
                if ($input.val() === 0) {
                    if (confirm('Are you sure you want to delete this item?')) {
                        FavoritesManager.deleteItem($(this).closest('.itemWrapper').attr('data-product-id'), listId);
                    } else {
                        $input.val($input.attr('data-originalval'));
                    }
                } else {
                    var diff = $input.val() - $input.attr('data-originalval');
                    Roc.Core.lockButton($button);
                    var updateData = {
                        'ListId': listId,
                        'ProductId': $(this).closest('.itemWrapper').attr('data-product-id'),
                        'Quantity': diff
                    };
                    FavoritesManager.updateItem(updateData);
                }
            }
        });
    }

    function listActionEvt() {
        $(document).on('change', '#listActions', function () {
            var selectedAction = parseInt($('option:selected', this).val());
            if (!isNaN(selectedAction)) {
                switch (selectedAction) {
                    case listActionsType.EDIT:
                        FavoritesManager.getList(listId, false);
                        break;
                    case listActionsType.DELETE:
                        if (confirm('Are you sure you want to delete this favorites list?')) {
                            FavoritesManager.deleteList(listId);
                        }
                        break;
                    case listActionsType.SHARE_PUBLIC:
                        //TODO: implement Share favorites list event
                        break;
                    case listActionsType.SHARE_PRIVATE:
                        Roc.UI.warning('This list is private, to share favorites list change its privacy to public');
                        break;
                }
            }
        });
    }

    // BP custom action
    function emailListEvt() {
        $(document).on('click', '[data-roc-action="emailList"]', function() {
            Customizations.openEmailList(listId);
        });
    }

    /**
     * make() returns a new element
     * based on the passed in tag name
     *
     * @param {Object} trigger - optional jquery object of trigger selector
     */
    function openCreateList(trigger) {
        Roc.UI.template('favoritesList-Tmp', {
            'createList': true
        }).then(function (renderedTemplate) {
            Roc.UI.Modal.open(renderedTemplate, {
                open: function () {
                    $(this.contentContainer).find('.cancelEditListBtn').click(function (e) {
                        itemToMove = null;
                    });
                },
                close: function () {
                    Roc.Core.releaseLockedButton(trigger);
                }
            });
        });
    }

    function createNewListBtnEvt() {
        $(document).on('click', '[data-roc-action="createNewFavoriteList"]', function (e) {
            var trigger = $(e.currentTarget);

            openCreateList(trigger);
            Roc.Core.lockButton(trigger);
        });
    }

    function saveCreateListEvt() {
        $(document).on('click', '#saveNewListBtn', function (e) {
            var $popupHtml = $.magnificPopup.instance.content;
            var trigger = e.currentTarget;

            var requestData = {
                'Privacy': parseInt($popupHtml.find('select.privacyLevel').val()),
                'Name': $popupHtml.find('input#favoritesName').val()
            }

            var form = {
                Fields: [
                    {
                        "Name": 'List Name',
                        "Field": $popupHtml.find('input#favoritesName'),
                        "Param": 'listName',
                        "Type": 'Text'
                    },
                    {
                        "Name": 'Privacy',
                        "Field": $popupHtml.find('select.privacyLevel'),
                        "Param": 'privacy',
                        "Type": 'Select'
                    }
                ],
                Validate: true
            };

            if (!Roc.Validation.validateForm(form)) {
                return false;
            }

            Roc.Core.lockButton(trigger);
            FavoritesManager.addList(requestData);
        });
    }

    function moveItemEvt() {
        $(document).on('change', '.moveItemSelect', function () {
            var moveToList = $(this).val();
            if (moveToList.length > 0) {
                var requestData = {
                    'FromListId': listId,
                    'ProductId': $(this).closest('.itemWrapper').attr('data-product-id')
                };
                if (moveToList === 'create') {
                    itemToMove = requestData;
                    openCreateList();
                } else {

                    requestData.ToListId = moveToList;
                    FavoritesManager.moveItem(requestData);
                }
            }
        });
    }

    function itemUpdatedInQuickView(data) {
        FavoritesManager.updateProduct(itemToUpdate.ItemId, data.productId, data.quantity);
    }

    function updateProductEvt() {
        $(document).on('click', '[data-roc-action="editItemFromFavorites"]', function () {
            var $itemWrapper = $(this).closest('.itemWrapper');
            var itemData = $itemWrapper.data();

            itemToUpdate = {
                'ListId': itemData.listId,
                'ProductId': itemData.productId,
                'WantsQty': $itemWrapper.find('input.wantsQty').val(),
                'ItemId': itemData.itemId,
                'GroupId': itemData.groupId
            };

            QuickView.getProduct(itemToUpdate.ProductId, {
                'action': Roc.Enums.quickViewAction.EDIT,
                'actionLabel': 'Save changes',
                'initialQuantity': itemToUpdate.WantsQty,
                'callback': itemUpdatedInQuickView,
                'groupId': itemToUpdate.GroupId
            });
        });
    }

    

    function addItemToCartEvt() {
        $(document).on('click', '[data-roc-action="addToCartFromFavorites"]', function () {
            var $itemWrapper = $(this).closest('.itemWrapper');
            var itemData = $itemWrapper.data();

            itemToUpdate = {
                'ListId': itemData.listId,
                'ProductId': itemData.productId,
                'AddQty': $itemWrapper.find('input.addQty').val(),
                'ItemId': itemData.itemId,
                'GroupId': itemData.groupId
            };
            var requestCustomFields = null;
            var tempAddressId = getTempAddressId();
            if (tempAddressId) {
                requestCustomFields = { "TempAddressId": tempAddressId };
            }

            //TODO: KITS
            if (itemData.productType === 'Group') {
                QuickView.getProduct(itemToUpdate.ProductId);
            } else {
                Roc.Core.lockButton('#btnAddToCart' + itemToUpdate.ItemId);
                //Customization for quotes
                Cart.CartLocker.isCartLocked()
                    .then(function() {
                        Cart.CartManager.addCartItem(itemToUpdate.ProductId,
                            itemToUpdate.AddQty,
                            itemToUpdate.GroupId,
                            null,
                            null,
                            null,
                            requestCustomFields);
                    });
            }
        });
    }

    function getTempAddressId() {
        return $('#hdnTempAddressId').val();
    }


    function countCharactersLeft() {
        $(document).on('keyup', '#commentsAndPriority textarea[name="comments"]', function () {
            var charsLeft = Roc.UI.countCharactersLeft('#commentsAndPriority textarea[name="comments"]');
            if (charsLeft !== null) {
                $(this).parent('.formee').find('.comments.remaining').html('Remaining: ' + charsLeft + ' character' + (charsLeft === 1 ? '' : 's'));
            }
        });
    }

    function reloadNewList(data) {
        if (data.Result === true && data.id) {
            if (itemToMove !== null) {
                itemToMove.ToListId = data.id;
                FavoritesManager.moveItem(itemToMove);
            } else {
                window.location.href = baseUrl + '?listId=' + data.id;
            }
        } else {
            Roc.UI.displayErrorPopup('There was an error while trying to create a new list. Please try again later.');
        }
    }

    function refreshControls(pg) {
        $('select#itemsSort option[data-sortby="' + pg.sortBy + '"][data-sortascending="' + pg.sortAscending + '"]').attr('selected', 'selected');
        $('select#itemFilter option[data-filtermin="' + (pg.filterMin !== null ? pg.filterMin : '') + '"][data-filtermax="' + (pg.filterMax !== null ? pg.filterMax : '') + '"]').attr('selected', 'selected');
        $('select#listActions option:first').attr('selected', 'selected');
        $('#editName').val('');
        $('.rateit').rateit();
    }

    function updatePagination(data) {
        pagination = Roc.Pagination.updatePaging(data);
    }

    function refreshFavoritesList(pg) {
        closeModal();

        if (!pg) {
            pg = pagination;
        }

        $.get(baseUrl, {
            'listId': listId, 'pageSize': pg.pageSize, 'page': pg.page, 'sortBy': pg.sortBy, 'sortAscending': pg.sortAscending, 'filterMin': pg.filterMin, 'filterMax': pg.filterMax
        }, function (data) {
            $('#items').html($('#items', data).html());
            var totalPages = parseInt($('#totalPages', data).val());
            updatePagination({ 'totalPages': totalPages });
            refreshControls(pg);
            Customizations.clearSelection();
        });
    }

    function reload() {
        if (itemToMove !== null) {
            var toListId = itemToMove.ToListId;
            itemToMove = null;
            reloadNewList({ 'Result': true, 'id': toListId });
        } else {
            refreshFavoritesList();
        }
    }

    function listDeletedEvt() {
        window.location.href = baseUrl;
    }

    function reloadPage(data) {
        if (data && data.Result === true) {
            window.location.reload();
        }
    }

    function bindEvents() {
        changeListNameEvt();
        createNewListBtnEvt();
        updateItemQtyEvt();
        deleteItemEvt();
        editItemEvt();
        saveEditItemEvt();
        // Handling list actions is customized in FavoritesCustomizations module
        //listActionEvt(); 
        saveEditListEvt();
        saveCreateListEvt();
        moveItemEvt();
        addItemToCartEvt();
        countCharactersLeft();
        updateProductEvt();
        emailListEvt();

        Roc.EventManager.bind(Roc.Events.favorites.GET_ITEM, displayEditItemEvt);
        Roc.EventManager.bind(Roc.Events.favorites.GET_LIST, displayEditListEvt);
        Roc.EventManager.bind(Roc.Events.favorites.MOVE_ITEM, reload);
        Roc.EventManager.bind(Roc.Events.favorites.UPDATE_ITEM, reload);
        Roc.EventManager.bind(Roc.Events.favorites.UPDATE_PRODUCT, reload);
        Roc.EventManager.bind(Roc.Events.favorites.UPDATE_LIST, reload);
        Roc.EventManager.bind(Roc.Events.favorites.ADD_LIST, reloadNewList);
        Roc.EventManager.bind(Roc.Events.favorites.DELETE_LIST, listDeletedEvt);
        Roc.EventManager.bind(Roc.Events.favorites.DELETE_ITEM, reload);
        Roc.EventManager.bind(Roc.Events.favorites.UPDATE_LIST, reloadPage);

        Roc.EventManager.bind(Roc.Events.cart.ADD_ITEM, function (xhr) {
            var data = xhr || {};

            if (!data.success) {
                var errorMessage = 'An error occurred while trying to add the item to your cart.';
                if (data && data.errorMessage) {
                    errorMessage = data.errorMessage;
                } else if (data.details && data.details.errorMessages && data.details.errorMessages.length > 0) {
                    errorMessage = '';
                    for (var i = 0; i < data.details.errorMessages.length; i++) {
                        errorMessage += data.details.errorMessages[i].errorMessage + '\n';
                    }
                }

                Roc.UI.displayErrorPopup(errorMessage);
                Roc.Core.releaseLockedButton('#btnAddToCart' + itemToUpdate.ItemId);
                return;
            }

            Roc.Core.releaseLockedButton('#btnAddToCart' + itemToUpdate.ItemId);
            itemToUpdate = null;
        });
    }

    function init(options) {
        bindEvents();
        baseUrl = options.baseUrl;
        listId = options.listId;
        pagination = Roc.Pagination.init(options, refreshFavoritesList);
        refreshControls(pagination);

        // init customiozations module
        Customizations.init();
        Customizations.setListId(options.listId);
    };

    var Favorites = {
        init: init
    };

    Roc.Logger.debug('Favorites.js Loaded:', Favorites);

    return Favorites;
});
